const { StyleSheet } = require("react-native");

const styles = StyleSheet.create({
  pressed: {
    opacity: 0.5,
  },
});

export default styles;
